export enum LanguageEnum {
  EN = 'EN',
  ES = 'ES',
}
